import styled from 'styled-components';

const MarketShareWrapper = styled.div`
  margin-block-end: 32px;
`;

export default MarketShareWrapper;
